import axios from 'axios';
import { get } from 'lodash'
import moment from 'moment';
import {
    RECOMMENDATION_FAILED,
    RECOMMENDATION_RESULTS
} from '../../actions/actionTypes';
import LocalStorage from "../../helpers/storage/LocalStorage";
import * as SessionFeatureFlags from '../featureflags/SessionFeatureFlags';
import {getAuthHeader} from "../../helpers/securityHelper";

export const DATE_FORMAT_US_SLASHES = 'MM/DD/YYYY';

export function addReferrer ({model, pageReferrer, entityId, entityType, locationId, nthItem}) {
    let refs = LocalStorage.getItem("recommendation-refs");
    if (!refs) {
        refs = {};
    }else{
        refs = JSON.parse(refs);
    }
    const referrer = `${model}:${pageReferrer}:${locationId}:${nthItem}`;
    refs[entityId] = {
        referrer,
        model,
        pageReferrer,
        entityId,
        entityType,
        locationId,
        nthItem
    };
    LocalStorage.setItem("recommendation-refs", JSON.stringify(refs));
}

export function getReferrerForLocation (locationId) {
    const refs = LocalStorage.getItem("recommendation-refs");
    if (refs) {
        return JSON.parse(refs)[locationId];
    }
    return null;
}

export function getRecommendationReferrerForLocation (locationId) {
    const referrer = getReferrerForLocation(locationId);
    if (referrer!=null) {
        return referrer.referrer;
    }
    return null;
}

export async function checkLogAddToCartConversion(locationId) {
    const referrer = getReferrerForLocation(locationId);
    if (referrer!=null) {
        await SessionFeatureFlags.logAddToCartConversion('recommendation-models', {location_id: locationId, model: referrer.model});
    }
}

export async function checkLogEcommerceConversion(locationId) {
    const referrer = getReferrerForLocation(locationId);
    if (referrer!=null) {
        await SessionFeatureFlags.logAddEcommercePurchaseConversion('recommendation-models', {location_id: locationId, model: referrer.model});
    }
}

const recommendationResults = (results) => ({
    type: RECOMMENDATION_RESULTS,
    results
});

const recommendationFailed = (errorMsg) => ({
    type: RECOMMENDATION_FAILED,
    errorMsg
});

export function getRecommendations (
    {
        model, location, area,
        state, startDate, endDate,
        includeUnavailable, includeNotReservable
    }) {
    return async (dispatch) => {
        try {
            const m = model || 'similar1';
            let url = `${process.env.API}/recommendation/recommend?m=${m}`;
            if (location) {
                url += `&l=${location}`;
            }
            if (area) {
                url += `&area=${area}`;
            }
            if (state) {
                url += `&state=${state}`;
            }
            if (startDate) {
                let dt = startDate;
                if (dt.includes("/") && moment(dt, DATE_FORMAT_US_SLASHES).isValid()) {
                    dt = moment(dt, DATE_FORMAT_US_SLASHES).utc().startOf('day').toISOString()
                }
                url += `&start_date=${dt}`;
            }
            if (endDate) {
                let dt = endDate;
                if (dt.includes("/") && moment(dt, DATE_FORMAT_US_SLASHES).isValid()) {
                    dt = moment(dt, DATE_FORMAT_US_SLASHES).utc().startOf('day').toISOString()
                }
                url += `&end_date=${dt}`;
            }
            if (includeUnavailable) {
                url += '&include_unavailable=true';
            }
            if (includeNotReservable) {
                url += '&include_notreservable=true';
            }
            url += '&size=50';
            const response = await axios.get(url, { headers: { Authorization: getAuthHeader() } });
            const results = get(response, 'data.results')
            if (results) {
                dispatch(recommendationResults(results));
            }
        }
        catch (error) {
            dispatch(recommendationFailed('Server Error'));
        }
    };
}

